import "./dashboard.scss";
import { useContext, useEffect } from "react";
import { Outlet } from "react-router-dom";
import AppInfoContext from "src/provider/state-manager/appInfoProvider";
import { MobileMenu, SideMenu } from "src/component";
import { Container } from "../app-styles";
import UserContext from "src/provider/state-manager/userProvider";
import { MemberTypeEnum } from "src/model";
import VisibilityContext from "src/provider/state-manager/visibilityProvider";
import DashboardModal from "src/app/dashboard/dashboardModal";

export const DashboardRoutes = () => {
  const { recoverStatesData } = useContext(AppInfoContext);
  const { user } = useContext(UserContext);
  const { visibility, setModal } = useContext(VisibilityContext);

  useEffect(() => {
    recoverStatesData();
  }, []);

  const handleLogoutModal = () =>
    setModal({ key: "showLogout", value: !visibility.showLogout });

  return (
    <div
      className={`
                dashboard-container 
                ${visibility.isModal ? "no-scroll" : ""} 
                ${
                  user?.profile?.memberType === MemberTypeEnum.STUDENT
                    ? "student-dashboard"
                    : ""
                }
            `}
    >
      <SideMenu
        handleModal={handleLogoutModal}
        memberType={user?.profile?.memberType}
      />
      <Container>
        <Outlet />
      </Container>
      <MobileMenu
        handleModal={handleLogoutModal}
        memberType={user?.profile?.memberType}
      />
      <DashboardModal />
    </div>
  );
};

export default {
    routeProps: {
        path: 'dashboard',
        element: <DashboardRoutes />
    },
    name: 'Dashboard'
}